module.exports = __webpack_public_path__ + "35ea0975a576615e0e83666af1093c6a.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/icons/icons.woff2
// module id = 385
// module chunks = 0